<template>
  <v-data-table :headers="headers" :items="items" class="elevation-1" expand>
    <template v-slot:item.name="{ item }">
      <div @click="onItemClick(item)" style="cursor: pointer">
        {{ item.name }} от {{ $moment(item.created_at).format('LL') }}
      </div>
    </template></v-data-table
  >
</template>

<script>
import { getTaskMetricsCountsResponse } from '@/api/activist/metrics'

export default {
  name: 'TaskCountsTable',
  data() {
    return {
      items: [],
      headers: [
        {
          text: 'Название',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'В работе',
          align: 'start',
          sortable: true,
          value: 'in_progress',
        },
        {
          text: 'Завершено',
          align: 'start',
          sortable: true,
          value: 'completed',
        },
        {
          text: 'Утверждено',
          align: 'start',
          sortable: true,
          value: 'approved',
        },
        {
          text: 'Отклонено',
          align: 'start',
          sortable: true,
          value: 'rejected',
        },
        {
          text: 'Отменено',
          align: 'start',
          sortable: true,
          value: 'canceled',
        },
      ],
    }
  },
  mounted() {
    this.getTasksCounts()
  },
  methods: {
    getTasksCounts() {
      getTaskMetricsCountsResponse(this.axios)
        .then((resp) => {
          this.$set(this, 'items', resp.data || [])
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
    onItemClick(item) {
      this.$router.push({ name: 'activist_taken_task_list', params: { task_id: item.id } })
    },
  },
}
</script>
